import { render, staticRenderFns } from "./instantPayment.vue?vue&type=template&id=c3f1ec0e&scoped=true"
import script from "./instantPayment.vue?vue&type=script&lang=js"
export * from "./instantPayment.vue?vue&type=script&lang=js"
import style0 from "./instantPayment.vue?vue&type=style&index=0&id=c3f1ec0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f1ec0e",
  null
  
)

export default component.exports